// extracted by mini-css-extract-plugin
export default {"wrapper":"kp","form":"lp","option":"mp","radio":"np","success":"op","contest":"pp"};